<template>

  <div>

      <!-- show loading indicator -->
  	<loading-indicator :loading="isLoading"></loading-indicator>

      <template v-if="!isLoading">

        <div class="max-width">
          <div class="info" style="margin-bottom:25px;"><lang labelKey="MAILCHIMP-START_INFO"></lang></div>

          <div class="section">
            <h3><lang labelKey="IMPORT-MAILCHIMP-RECIPIENTS"></lang></h3>
            <div class="info"><lang labelKey="IMPORT-MAILCHIMP-RECIPIENTS-INFO"></lang></div>
            <a class="button download" href="/static/downloads/newsletter-recipients.xlsx" download="newsletter-recipients.xlsx">
              <span class="icon is-small"><i class="icon-ak-download"></i></span>Download Leer-Vorlage für Upload
            </a>

          </div>

          <div style="margin-bottom: 48px;">
            <vue-dropzone
                ref="vueDropzoneXls"
                id="vueDropzoneXls"
                url= "fileProcessing/upload?preset=siteNewsletterRecipients"
                :maxFiles="1"
                :thumbnailWidth="100"
                :thumbnailHeight="100"
                :autoProcessQueue="false"
                acceptedFiles= ".xls,.xlsx"
                dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Excel Datei hochladen"
                v-on:vdropzone-file-added="dzFileAdded"
                v-on:vdropzone-files-added="dzFileAdded"
                v-on:vdropzone-sending="dzBeforeSending"

                v-on:vdropzone-removed-file="dzRemoveFile"
                v-on:vdropzone-mounted="dzInit"
                v-on:vdropzone-success="dzSuccess"
                style="margin-bottom: 12px;">
            </vue-dropzone>

            <alert icon="exclamation" style="white-space: normal !important;">Bitte stellen Sie sicher, dass Sie ausschließlich E-Mail-Adressen von Personen hochladen und für Ihren Newsletter verwenden, deren Besitzer dem Empfang von Newslettern ausdrücklich zugestimmt haben.</alert>
          </div>
        </div>

        <v-client-table
          ref="tblNewsletterRecipients"
          name="tblNewsletterRecipients"
          :data="recipients.data"
          :columns="recipients.columns"
          :options="recipients.options"
          class="tbl-newsletterRecipients noFirstColumn">

            <template slot="edit" slot-scope="props">
                <pop-confirm class="icon is-small" content="Soll dieser Empfänger wirklich entfernt werden?" icon="question-circle-o" :on-ok="function() { recipientDelete(props) }" :on-cancel="cancel" cancel-text="nein" ok-text="löschen">
                    <i class="icon-ak-entfernen"></i>
                </pop-confirm>
            </template>

        </v-client-table>

        <div class="max-width">
          <div class="section">
            <h3><lang labelKey="EXPORT-MAILCHIMP-RECIPIENTS"></lang></h3>
            <div class="info"><lang labelKey="EXPORT-MAILCHIMP-RECIPIENTS-INFO"></lang></div>
            <export-button export="newsletterRecipients" modalTitle="NEWSLETTER-MODAL_HEADER-EXPORT_RECIPIENTS" btnTitle="NEWSLETTER-BTN-EXPORT" :exportId="siteId"></export-button>
          </div>

          <div class="section">
            <h3><lang labelKey="EXPORT-APOPOINT-NEWSLETTER-LIST"></lang></h3>
            <div class="info"><lang labelKey="EXPORT-APOPOINT-NEWSLETTER-LIST-INFO"></lang></div>
            <export-button v-if="activeUser.site && activeUser.site.hasApoPoint === true" :downloadOnly="true" export="newsletterSubscribers" modalTitle="NEWSLETTER-MODAL_HEADER-EXPORT_SUBSCRIBERS" btnTitle="NEWSLETTER-BTN-EXPORT-SUBSCRIBERS" :exportId="siteId"></export-button>
          </div>
        </div>
      </template>


      <!-- MODAL -->
      <modal
          :width="modal.width"
          :title="modal.title"
          transition="fadeDown"
          :show-ok="false"
          :show-cancel="false"
          cancel-text="Abbrechen"
          :backdrop-closable="false"
          :is-show="showModal"
          :class="modal.class"
          @close="closeModal">

              <template v-if="modal.isLoading">
                  <loading-indicator></loading-indicator>
              </template>

              <template v-else>

                  <template v-if="modal.type=='confirm'">

                    Sollen die Newsletter Empfänger neu eingespielt oder ergänzt werden?<br>(Beim Neu-Einspielen werden alle alten Einträge entfernt)

                    <div slot="footer">
                      <!-- <span class="button" @click="closeModal">abbrechen</span> -->
                      <span class="button" @click="proceedUploading(true)">Neu Einspielen</span>
                      <span class="button is-success" @click="proceedUploading(false)">Ergänzen</span>
                    </div>

                  </template>


                  <template v-else>


                    <!-- PROGRESS NEWSLETTER RECIPIENT -->
                    <template v-if="progressStatus == null">

                      <loading-indicator-small></loading-indicator-small>

                    </template>

                    <template v-else>

                      <template v-if="progressStatus.status != 'Finished'">

                          <div class="has-text-centered" style="margin-bottom: 5px;">{{ progressStatus.log }}</div>
                          <progress-bar :percent="progressStatus.progress" :showinfo="false" :striped="true" :animated="true" size="large"></progress-bar>

                      </template>

                      <template v-else>

                          <div class="has-text-centered">Empfänger erfolgreich hochgeladen</div>

                      </template>

                    </template>

                    <div slot="footer">
                      <span class="button" @click="closeModal">{{ (progressStatus == null || progressStatus.status != 'Finished') ? 'abbrechen' : 'schließen' }}</span>
                    </div>

                  </template>

              </template>

      </modal>

  </div>

</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

import exportButton from '../utils/exportButton';
import vue2Dropzone from '../utils/dropzoneWrapper';

export default {

    components: {
        vueDropzone: vue2Dropzone,
        exportButton
    },

    data() {

        return {

            isLoading: false,
            showModal: false,

            progressStatus: null,
            refreshIntervalId: 0,

            // appendedFormData: [],
            clearData: false,

            modal: {
              isLoading: false,
              isSaving: false,
              type: '',
              title: '',
              width: '640',
              class: ''
            },

            // RECIPIENTS
            recipients: {

                data: [],
                columns: ['salutation', 'lastname', 'firstname', 'email', 'origin', 'edit'],
                options: {
                    trackBy: 'email',
                    uniqueKey: 'email',
                    saveState: false,
                    perPage: 15,
                    orderBy: {
                        ascending: true,
                        column: 'lastname'
                    },

                    // custom table headings
                    headings: {

                        /*
                        salutation(h) {
                            return <lang labelKey="NEWSLETTER-RECIPIENTS-TBL_HEADER-SALUTATION"></lang>
                        },
                        firstname(h) {
                            return <lang labelKey="NEWSLETTER-RECIPIENTS-TBL_HEADER-FIRSTNAME"></lang>
                        },
                        lastname(h) {
                            return <lang labelKey="NEWSLETTER-RECIPIENTS-TBL_HEADER-LASTNAME"></lang>
                        },
                        email(h) {
                            return <lang labelKey="NEWSLETTER-RECIPIENTS-TBL_HEADER-EMAIL"></lang>
                        },
                        origin(h) {
                            return <lang labelKey="NEWSLETTER-RECIPIENTS-TBL_HEADER-ORIGIN"></lang>
                        },
                        edit(h) {
                            return '';
                        }
                        */

                        email(h) {
                            return <lang labelKey="NEWSLETTER-RECIPIENTS-TBL_HEADER-EMAIL"></lang>
                        },
                        firstname(h) {
                            return <lang labelKey="NEWSLETTER-RECIPIENTS-TBL_HEADER-FIRSTNAME"></lang>
                        },
                        lastname(h) {
                            return <lang labelKey="NEWSLETTER-RECIPIENTS-TBL_HEADER-LASTNAME"></lang>
                        },
                        salutation(h) {
                            return <lang labelKey="NEWSLETTER-RECIPIENTS-TBL_HEADER-SALUTATION"></lang>
                        },
                        origin(h) {
                            return <lang labelKey="NEWSLETTER-RECIPIENTS-TBL_HEADER-ORIGIN"></lang>
                        },
                        edit(h) {
                            return '';
                        }
                    },

                    columnsClasses: { 'edit': 'edit' },

                    sortable: ['firstname', 'lastname', 'email'],

                    sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },
                    filterByColumn: false,
                    filterable: false,

                    texts: {
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'keine passenden Einträge gefunden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },

                    pagination: {
                        chunk: 5
                    },

                    skin: 'table is-hoverable is-fullwidth',

                }
            },


        }
    },

    computed: {

      siteId() {
        return this.activeUser.site != null ? this.activeUser.site.id : 546;
      },

    },

    created() {

      this.fetchRecipients();

    },

    methods: {

      proceedUploading(clearData) {

        this.clearData = clearData;
        this.$refs.vueDropzoneXls.$children[0].processQueue();

      },

      dzFileAdded(file) {

        this.modal.type = 'confirm';
        this.modal.title = 'Neu einspielen oder ergänzen?';
        this.modal.width = '640';
        this.showModal = true;

      },

      dzBeforeSending(file, xhr, formData) {

        formData.append('site', this.siteId);
        formData.append('clear', this.clearData);

      },

      dzInit() {

      },

      dzSuccess(file, response) {

        this.modal.isLoading = false;
        this.modal.isSaving = false;
        this.modal.type = 'progress';
        this.modal.title = 'Verarbeitung';
        this.modal.width = '640';
        this.modal.class = 'progressModal';

        this.showModal = true;

        this.$refs.vueDropzoneXls.$children[0].removeAllFiles();
        let taskLogId = response.taskLogId;

        this.refreshIntervalId = setInterval(() => {

            this.axios.get(this.$config.api + 'taskLog/' + taskLogId)
                .then((response) => {

                    this.progressStatus = response.data;

                    if(['Finished', 'Error'].indexOf(response.data.status) > -1) {

                        clearInterval(this.refreshIntervalId);

                        this.axios.get(this.$config.api + 'newsletter/subscribers?site='+this.siteId)
                            .then((res) => {
                                this.$notify.open({ content: 'Daten wurden erfolgreich importiert!', type: 'success'})
                                this.recipients.data = res.data;
                                setTimeout(() => {
                                  this.closeModal();
                                }, 1500);
                            })
                    }

                });

        }, 1000);


        setTimeout(() => {
            this.closeModal();
        }, 100000);

      },


      closeModal() {

        // in case we've running an interval
        clearInterval(this.refreshIntervalId);

        // make sure to remove alle quequed files
        if(this.$refs.vueDropzoneXls.$children[0]) {
          this.$refs.vueDropzoneXls.$children[0].removeAllFiles(true);
        }

        this.progressStatus = null;
        this.clearData = false;

        this.modal.isSaving = false;
        this.showModal = false;

      },

      recipientDelete(props) {

        let index = this.recipients.data.findIndex(function(recipient) {
            return recipient.email == props.row.email;
        })

        this.axios.get(this.$config.api + 'newsletter/unsubscribe?site='+this.siteId+'&subscriberEmail='+this.recipients.data[index].email)
            .then((response) => {
                this.recipients.data.splice(index, 1);
                this.$notify.open({ content: 'Empfänger wurde erfolgreich entfernt', type: 'success'});
            })

      },


      fetchRecipients() {

        this.isLoading = true;

        this.axios.get(this.$config.api + 'newsletter/subscribers?site='+this.siteId)
            .then(res => {

                this.recipients.data = res.data;
                this.isLoading = false;

            })

      },
    }
}
</script>


<style lang="scss" scoped>

  .button.download { /* overwrite, because tabs a is overwriting button styles */
    align-items: center !important;
    background-color: #fff !important;
    border: 1px solid #dbdbdb !important;
    border-radius: 3px !important;
    color: #363636 !important;
    display: inline-flex !important;
    font-size: 14px !important;
    height: 32px !important;
    justify-content: center !important;
    line-height: 24px !important;
    position: relative;
    vertical-align: top;
    user-select: none !important;
    cursor: pointer;
    padding-left: 10px !important;
    padding-right: 10px !important;
    text-align: center !important;
    white-space: nowrap !important;
  }

  .max-width {
    max-width: 640px;
    margin: 0 auto;
  }
  .tbl-newsletterRecipients {
    margin: 0 auto;
    width: 100%;
    max-width: 85%;
    margin-bottom: 48px;
  }

  .section {
    margin-bottom: 32px;
    padding: 0;

    h3 {
      margin-bottom: 12px;
      font-size: 22px;
    }
    .info {
      white-space: normal;
      margin-bottom: 12px;
    }
  }

</style>
